export interface GisLayer {
  id: string;
  name: string;
  type: 'basemap' | 'terrain' | '3d-tiles' | 'wms' | 'wmts' | 'geojson';
  url: string;
  visible: boolean;
  opacity: number;
  config?: Record<string, unknown>;
}

export interface GisSceneState {
  viewerMode: '3d' | '2d' | 'ColumbusView';
  enableLighting: boolean;
  showTerrain: boolean;
  showSkyAtmosphere: boolean;
  depthTestAgainstTerrain: boolean;
  layers: GisLayer[];
  camera: {
    longitude: number;
    latitude: number;
    height: number;
    heading: number;
    pitch: number;
    roll: number;
  };
}

export const DEFAULT_GIS_CAMERA = {
  longitude: 116.397428,
  latitude: 39.90923,
  height: 10000000,
  heading: 0,
  pitch: -90,
  roll: 0,
};
